import { flex } from "@mui/system";
import { useMemo } from "react";
import { debounce } from "@mui/material";
import { inventoryFields } from "./inventoryField";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getItemListbyCode } from "../../../services/skuItem/skuItem";
import { getLocationCodeAutoAPI } from "../../../services/location/location";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { getChannel } from "../../../services/channel/channel";
export default function CreateInventory({ onSubmit, onCancel, viewOnly, isEdit, initialValues }) {
  const { userDetail } = useSelector(state => state.login);
  const [formData, setFormData] = useState({
    itemCode: "",
    itemDescription: "",
    locationId: "",
    locationName: "",
    locationType: "",
    stockOnHand: "",
    allocatedQty: 0,
    availableQty: 0,
    batchLot: "",
    expiryDate: "",
    availability: "",
    nonSellableQty: 0,
    createdBy: userDetail?.email,
    updatedBy: "",
    channelAllocation: [{ channelId: '', allocationPercent: '', disable: false }]
  });
  const [locationDataList, setlocationDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [channels, setChannelsData] = useState([]);
  const [items] = useState([]);
  const [locations] = useState([]);


  useEffect(() => {
    if (viewOnly || isEdit) {
      getLocation(initialValues.locationId.locationID);
      getItem(initialValues.itemCode.itemCode);
      // console.log(initialValues,"initialValues");
      setFormData({
        ...initialValues, itemCode: initialValues.itemCode._id, locationId: initialValues.locationId._id,
        locationName: initialValues.locationId.locationName, locationType: initialValues.locationId.locationType,
        stockOnHand: initialValues.soh, batchLot: initialValues.batch, expiryDate: new Date(initialValues.batchExpiryDate),
        availability: initialValues.availablity, allocatedQty: initialValues.allocatedQty, nonSellableQty: initialValues.nonSellableQty,
        channelAllocation: initialValues.channelAllocation.map((m) => ({ channelId: m.channelId._id, allocationPercent: m.allocationPer, disable: true }))
      })
    }

  }, [initialValues, viewOnly])

  useEffect(() => {
    fetchChannels();
  }, []);


  const fetchChannels = async () => {
    try {
      let res = await getChannel();
      if (res && res.length) {
        setChannelsData(res);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleItemCode = (e, value) => {
    setFormData((prev) => ({ ...prev, itemCode: value._id, itemDescription: value.itemName }));
  }

  const handleLocationCode = (e, value) => {
    setFormData((prev) => ({ ...prev, locationId: value._id, locationName: value.locationName, locationType: value.locationType }));
  }


  const handleItemSearch = (value) => {
    if (!value || value.length < 2) return;
    debouncedGetItem(value);
  };

  const handleLocationSearch = (value) => {
    if (!value || value.length < 2) return;
    debouncedGetLocation(value);
  };

  const debouncedGetItem = useMemo(
    () =>
      debounce((value) => {
        console.log("helllooo");

        getItem(value);
      }, 2000),
    []
  );

  const debouncedGetLocation = useMemo(
    () =>
      debounce((value) => {
        getLocation(value);
      }, 2000),
    []
  );
  const getLocation = async (value) => {
    try {
      let res = await getLocationCodeAutoAPI(value);
      if (res.length != 0) {
        setlocationDataList(res);
      }
    }
    catch (err) {
    }
  }

  const getItem = async (value) => {
    try {
      let res = await getItemListbyCode({ itemCode: value });
      if (res.length != 0) {
        setItemDataList(res);
      }
      else {
      }
    }
    catch (err) {
    }
  }

  const handleChange = (name, value) => {
    let updated = { ...formData, [name]: value };
    if (name === "stockOnHand") {
      updated.availableQty = value - formData.allocatedQty;
    }
    setFormData(updated);
  };

  const handleChannelChange = (index, field, value) => {
    const updated = [...formData.channelAllocation];
    updated[index][field] = value;
    setFormData({ ...formData, channelAllocation: updated });
  };

  const addChannelRow = () => {
    setFormData({
      ...formData,
      channelAllocation: [
        ...formData.channelAllocation,
        { channelId: "", allocationPercent: "" }
      ]
    });
  };

  const removeChannelRow = (index) => {
    const updated = formData.channelAllocation.filter((_, i) => i !== index);
    setFormData({ ...formData, channelAllocation: updated });
  };

  const submit = (e) => {
    e.preventDefault();
    if (isEdit) {
      onSubmit(formData, initialValues._id);
    }
    else {
      onSubmit(formData)
    }


  };

  return (
    <form>
      <div className="d-flex flex-wrap gap-3">
        {inventoryFields.map((field) => {
          if (field.type === "array") {
            return (
              <div key={field.name} style={{ width: "96%" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <label className="form-label">{field.label}</label>
                  <button
                    hidden={viewOnly}
                    type="button"
                    className="btn btn-secondary"
                    onClick={addChannelRow}
                  >
                    + Add Channel
                  </button></div>

                {formData.channelAllocation.map((row, index) => (
                  <div key={index} className="d-flex gap-2 mb-1 mt-1">
                    <select
                      className="form-select"
                      value={row.channelId}
                      disabled={viewOnly || row.disable}

                      onChange={(e) =>
                        handleChannelChange(index, "channelId", e.target.value)
                      }
                    >
                      <option value="">Select Channel</option>
                      {channels.map((ch) => (
                        <option key={ch._id} value={ch._id}>
                          {ch.channel_Name}
                        </option>
                      ))}
                    </select>

                    <input
                      type="number"
                      className="form-control"
                      placeholder="Allocation %"
                      value={row.allocationPercent}
                      readOnly={viewOnly}
                      onChange={(e) =>
                        handleChannelChange(index, "allocationPercent", e.target.value)
                      }
                    />

                    <button hidden={formData.channelAllocation.length < 2 || viewOnly}
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeChannelRow(index)}
                      disabled={row.disable}
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>
            );
          }

          return (
            <div
              key={field.name}
              className="mb-1"
              style={{ flex: "0 0 15%" }}
            >
              <label className="form-label">
                {field.label}
                {field.required && <span className="text-danger">*</span>}
              </label>
              {field.type === "select" ? (
                <select
                  className="form-select"
                  value={formData[field.name] || ""}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  disabled={viewOnly || field.readonly}
                >
                  <option value="">Select</option>
                  {field.name === "locationId" &&
                    locations.map((loc) => (
                      <option key={loc._id} value={loc._id}>
                        {loc.locationName}
                      </option>
                    ))}

                  {field.options &&
                    field.options.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                </select>
              ) :
                field.type === "autocomplete" ? (
                  field.name == 'itemCode' ? (


                    <Autocomplete
                      disablePortal
                      readOnly={viewOnly || isEdit}
                      options={itemDataList}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: 40,
                        }
                      }}
                      value={
                        itemDataList.find(item => item._id === formData.itemCode) || null
                      }
                      onChange={(e, newValue) => handleItemCode(e, newValue)}
                      onInputChange={(e, value) => handleItemSearch(value)}
                      getOptionLabel={(option) => option?.itemCode || ""}
                      renderInput={(params) => <TextField {...params} label="" />}
                    />

                  ) :

                    <Autocomplete
                      disablePortal
                      readOnly={viewOnly || isEdit}
                      options={locationDataList}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: 40,
                        }
                      }}
                      value={
                        locationDataList.find(item => item._id === formData.locationId) || null
                      }
                      onChange={(e, newValue) => handleLocationCode(e, newValue)}
                      onInputChange={(e, value) => handleLocationSearch(value)}
                      getOptionLabel={(option) => option?.locationID || ""}
                      renderInput={(params) => <TextField {...params} label="" />}
                    />
                ) :

                  (
                    <input
                      type={field.type || "text"}
                      className="form-control"
                      value={field.type == "text" ? formData[field.name] || "" : formData[field.name]}
                      onChange={(e) => handleChange(field.name, e.target.value)}
                      readOnly={viewOnly || field.readonly || ((field.name == 'batchLot' || field.name == 'expiryDate') && isEdit)}
                    />
                  )}
            </div>
          );
        })}
      </div>

      <div className="d-flex justify-content-center gap-2 mt-3">
        <button className="btn btn-secondary" onClick={onCancel}>
          Back
        </button>

        {!viewOnly && (
          <button className="btn btn-primary" onClick={submit}>
            {isEdit ? 'Update' : 'Save'}
          </button>
        )}
      </div>
    </form>
  );
}